import { IChangeStudentWordExamDateTimeResultVm } from '../../../../api/change-student-word-exam-date-time-result-vm.model';
import { WordExamModifiedDateService } from '../../../../api/api-services/word-exam-modified-date.service';
import { IMyOskStudentExamChangeDateIm } from '../../../../api/my-osk-student-exam-change-date-im.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { eModalRoles } from '../../../shared/models/modals';
import { Component, inject, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import dayjs from 'dayjs';
import { IWordExamModifiedDateIm } from '../../../../api/word-exam-modified-date-im.model';
import { IWordExamVm } from '../../../../api/word-exam-vm.model';

@Component({
  selector: 'app-exam-date',
  templateUrl: './exam-date.component.html',
  styleUrl: './exam-date.component.scss',
})
export class ExamDateComponent implements OnInit {
  private _wordExamModifiedDateService= inject(WordExamModifiedDateService);
  private _messageService = inject(MessageService);
  private _confifg = inject(DynamicDialogConfig);
  private _dialogRef = inject(DynamicDialogRef);

  public examDate: Date = new Date();
  public loading: boolean = false;
  public showNothingChangedMessage: boolean = false;
  maxDate: Date = new Date();
  
  private data: {
    studentWordExamGuid: string;
    finishedDate: Date;
  } = this._confifg.data;

  ngOnInit(): void {
    this.examDate = new Date(this.data.finishedDate);
  }

  ngOnDestroy(): void {}

  saveChanges(): void {
    const formattedDateString = this.getFormattedDate();

    if (formattedDateString === this.formatLocal(this.data.finishedDate)) {
      this.showNothingChangedMessage = true;
    } else {
      this.updateFinishedDate(formattedDateString);
    }
  }

  closeDialog(status: eModalRoles = eModalRoles.CLOSE, examEndDate: Date = this.data.finishedDate): void {
    this._dialogRef.close({status, examEndDate});
  }

  // The API stores (and returns) the exam date without any timezone information, and the whole
  // panel renders it as-is. Converting the picked date to UTC before sending it made the saved
  // date jump back by the local UTC offset (2h in Poland), so the OSK saw a different hour than
  // the one it selected. Send the picked wall clock time instead.
  private getFormattedDate(): string {
    return this.formatLocal(this.examDate);
  }

  private formatLocal(value: Date | string): string {
    return dayjs(value).format('YYYY-MM-DDTHH:mm:ss');
  }

  private updateFinishedDate(newExamDate: string): void {
    this.loading = true;
    const payload: IWordExamModifiedDateIm = {
      wordExamGuid: this.data.studentWordExamGuid,
      newExamDate,
    };

    this._wordExamModifiedDateService.post(payload).subscribe({
      next: (res: IWordExamVm) => {
        if (res) {
          this.handleSuccess();
          this.closeDialog(eModalRoles.REFRESH, dayjs(newExamDate).toDate());
        } else {
          this.handleError('Nie można zmienić daty egzaminu. Spróbuj ponownie później.');
        }
      },
      error: () => this.handleError('Wystąpił błąd. Spróbuj ponownie później.'),
    });
  }

  private handleSuccess(): void {
    this.loading = false;
    this._messageService.add({
      severity: 'success',
      summary: 'Sukces',
      detail: 'Data egzaminu została zmieniona',
    });
  }

  private handleError(message: string): void {
    this.loading = false;
    this._messageService.add({
      severity: 'error',
      summary: 'Błąd',
      detail: message,
    });
  }
}
